(function () {
  function qs(el, sel) { return el ? el.querySelector(sel) : null; }
  function qsa(el, sel) { return el ? Array.from(el.querySelectorAll(sel)) : []; }

  function lockScroll(lock) {
    if (lock) {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      document.body.dataset.zkScrollY = String(scrollY);
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    } else {
      const y = parseInt(document.body.dataset.zkScrollY || '0', 10);
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      delete document.body.dataset.zkScrollY;
      window.scrollTo(0, y);
    }
  }

  function formatCO(n) {
    const num = Number(n);
    if (!Number.isFinite(num)) return '';
    return Math.round(num).toLocaleString('es-CO');
  }

  function unformatCO(str) {
    return String(str || '').replace(/[^\d]/g, '');
  }

  function clamp(v, min, max) {
    return Math.min(max, Math.max(min, v));
  }

  function init(root) {
    const btnOpen = qs(root, '[data-zk-mf-open]');
    const overlay = qs(root, '[data-zk-mf-overlay]');
    const drawer = qs(root, '[data-zk-mf-drawer]');
    const btnClose = qs(root, '[data-zk-mf-close]');
    const form = qs(root, '[data-zk-mf-form]');

    if (!btnOpen || !overlay || !drawer || !btnClose || !form) return;

    function open() {
      document.body.classList.add('zk-mf-open');
      btnOpen.setAttribute('aria-expanded', 'true');
      overlay.setAttribute('aria-hidden', 'false');
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    }

    function close() {
      document.body.classList.remove('zk-mf-open');
      btnOpen.setAttribute('aria-expanded', 'false');
      overlay.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }

    btnOpen.addEventListener('click', open);
    btnClose.addEventListener('click', close);
    overlay.addEventListener('click', close);

    document.addEventListener('click', (e) => {
      if (!document.body.classList.contains('zk-mf-open')) return;
      const clickedInsideDrawer = drawer.contains(e.target);
      const clickedOpenBtn = btnOpen.contains(e.target);
      if (!clickedInsideDrawer && !clickedOpenBtn) close();
    }, true);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('zk-mf-open')) close();
    });

    // ===== Precio custom =====
    const priceBlock = qs(root, '[data-zk-price-block]');
    if (!priceBlock) return;

    const MAX = parseInt(priceBlock.getAttribute('data-zk-max') || '3000000', 10);

    const minI = qs(priceBlock, '[data-zk-mf-min]');
    const maxI = qs(priceBlock, '[data-zk-mf-max]');
    const dual = qs(priceBlock, '[data-zk-dual]');
    const fill = qs(priceBlock, '[data-zk-fill]');
    const thumbs = qsa(priceBlock, '[data-zk-thumb]');

    const thumbMin = qs(priceBlock, '[data-zk-thumb="min"]');
    const thumbMax = qs(priceBlock, '[data-zk-thumb="max"]');
// ===== FORZAR estilos inline (anti-CSS del tema / iOS) =====
const track = dual.querySelector('.zk-mf__track');
if (track) {
  track.style.position = 'absolute';
  track.style.left = '0';
  track.style.right = '0';
  track.style.top = '50%';
  track.style.transform = 'translateY(-50%)';
  track.style.height = '8px';
  track.style.borderRadius = '999px';
  track.style.background = '#e5e5e5';
  track.style.zIndex = '1';
  track.style.display = 'block';
  track.style.opacity = '1';
}

fill.style.position = 'absolute';
fill.style.top = '50%';
fill.style.transform = 'translateY(-50%)';
fill.style.height = '8px';
fill.style.borderRadius = '999px';
fill.style.background = '#5CA6D1';
fill.style.zIndex = '2';
fill.style.display = 'block';
fill.style.opacity = '1';

    if (!minI || !maxI || !dual || !fill || !thumbMin || !thumbMax) return;

    let minVal = clamp(parseInt(minI.value || '0', 10), 0, MAX);
    let maxVal = clamp(parseInt(maxI.value || String(MAX), 10), 0, MAX);
    if (maxVal > MAX) maxVal = MAX;
    if (minVal > maxVal) minVal = maxVal;

    function setUI() {
      // inputs formateados
      minI.value = formatCO(minVal);
      maxI.value = formatCO(maxVal);

      // posiciones %
      const minPct = (minVal / MAX) * 100;
      const maxPct = (maxVal / MAX) * 100;

      thumbMin.style.left = `${minPct}%`;
      thumbMax.style.left = `${maxPct}%`;

      fill.style.left = `${minPct}%`;
      fill.style.width = `${Math.max(0, maxPct - minPct)}%`;
    }

    setUI();

    function valueFromClientX(clientX) {
      const rect = dual.getBoundingClientRect();
      const x = clamp(clientX - rect.left, 0, rect.width);
      const pct = rect.width === 0 ? 0 : (x / rect.width);
      return clamp(Math.round(pct * MAX), 0, MAX);
    }

    let dragging = null;

    function startDrag(which, clientX) {
      dragging = which;
      // al iniciar: mover al punto donde tocó
      const v = valueFromClientX(clientX);
      if (which === 'min') {
        minVal = Math.min(v, maxVal);
      } else {
        maxVal = Math.max(v, minVal);
      }
      setUI();
      document.addEventListener('pointermove', onMove, { passive: false });
      document.addEventListener('pointerup', onUp, { passive: true });
    }

    function onMove(e) {
      if (!dragging) return;
      e.preventDefault();
      const v = valueFromClientX(e.clientX);
      if (dragging === 'min') {
        minVal = Math.min(v, maxVal);
      } else {
        maxVal = Math.max(v, minVal);
      }
      setUI();
    }

    function onUp() {
      dragging = null;
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
    }

    // Pointer events (iOS moderno)
    thumbMin.addEventListener('pointerdown', (e) => startDrag('min', e.clientX));
    thumbMax.addEventListener('pointerdown', (e) => startDrag('max', e.clientX));

    // Tap en la barra: mueve el más cercano
    dual.addEventListener('pointerdown', (e) => {
      // si tocó directamente una bolita, no duplicamos
      if (e.target === thumbMin || e.target === thumbMax) return;
      const v = valueFromClientX(e.clientX);
      const distToMin = Math.abs(v - minVal);
      const distToMax = Math.abs(v - maxVal);
      const which = distToMin <= distToMax ? 'min' : 'max';
      startDrag(which, e.clientX);
    });

    // Typing con puntos
    function handleTyping(which) {
      return (e) => {
        const raw = unformatCO(e.target.value);
        let v = clamp(parseInt(raw || '0', 10), 0, MAX);

        if (which === 'min') {
          v = Math.min(v, maxVal);
          minVal = v;
        } else {
          v = Math.max(v, minVal);
          maxVal = v;
        }
        setUI();
      };
    }

    minI.addEventListener('input', handleTyping('min'));
    maxI.addEventListener('input', handleTyping('max'));

    minI.addEventListener('blur', () => { minI.value = formatCO(minVal); });
    maxI.addEventListener('blur', () => { maxI.value = formatCO(maxVal); });

    // Enviar: sin puntos para Shopify
    form.addEventListener('submit', () => {
      minI.value = String(minVal);
      maxI.value = String(maxVal);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-zk-mf]').forEach(init);
  });
})();
